import React from "react";

const SiteFooter = ({translations}) => (
  <footer className="bg-white py-5">
  <div className="max-w-6xl mx-auto px-4 text-center">
    <p>
      &copy; {new Date().getFullYear()} Liad Music.{" "}
      {translations.footer.rights}
    </p>
  </div>
</footer>
);

export default SiteFooter;